declare global {
    // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
    interface Object {
        /**
         * Calls the specified function block with `this` value as its argument and returns its result
         * @param block - The function to be executed with `this` as argument
         * @returns `block`'s result
         */
        // eslint-disable-next-line @typescript-eslint/method-signature-style
        let<T, R>(this: T | null | undefined, block: (it: T) => R): R;

        /**
         * Calls the specified function block with `this` value as its argument and returns `this` value
         * @param block - The function to be executed with `this` as argument
         * @returns `this`
         */
        // eslint-disable-next-line @typescript-eslint/method-signature-style
        also<T>(this: T | null | undefined, block: (it: T) => void): T;
    }

    // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
    interface Array<T> {
        // eslint-disable-next-line @typescript-eslint/method-signature-style
        mapNotNull<U>(
            callbackfn: (value: T, index: number) => U
        ): Array<NonNullable<U>>;

        // eslint-disable-next-line @typescript-eslint/method-signature-style
        joinToString(
            callbackfn: (value: T, index: number) => string,
            separator?: string
        ): string;
    }
}

Object.defineProperty(Object.prototype, 'let', {
    // biome-ignore lint/suspicious/noExplicitAny: does not apply
    value(block: (arg0: any) => any) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return block(this);
    },
    enumerable: false,
});

Object.defineProperty(Object.prototype, 'also', {
    // biome-ignore lint/suspicious/noExplicitAny: does not apply
    value(block: (arg0: any) => any) {
        block(this);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return this;
    },
    enumerable: false,
});

// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
if (!Array.prototype.mapNotNull) {
    Array.prototype.mapNotNull = function <T, U>(
        this: Array<T>,
        callbackfn: (value: T, index: number) => U
    ): Array<NonNullable<U>> {
        return new Array<NonNullable<U>>().also((it) => {
            this.forEach((value, index) => {
                const result = callbackfn(value, index);
                if (result !== undefined && result !== null) {
                    it.push(result);
                }
            });
        });
    };
}

// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
if (!Array.prototype.joinToString) {
    Array.prototype.joinToString = function <T>(
        this: Array<T>,
        callbackfn: (value: T, index: number) => string,
        separator?: string
    ): string {
        let str = '';
        this.forEach((value, index) => {
            const sep = separator && index < this.length - 1 ? separator : '';
            str += callbackfn(value, index) + sep;
        });
        return str;
    };
}
